/**
 * Created by Federico Brocco on 13/05/2022.
 *
 * @format
 */

/**
 * Recupera i dati del comune e della homepage, impostando le variabili globali
 * @returns {Promise<Object>} Promise che risolve con i dati del comune e delle categorie
 */
let detail = function () {
    console.log('chiamata api: ', window.route.homepage);
    return new Promise(function (resolve, reject) {
        fetch(window.route.homepage, {
            method: 'GET'
        })
            .then((response) => response.json())
            .then((responseJson) => {
                try{
                    window.municipalityData = responseJson;
                    window.categories = responseJson.categories;
                    resolve(responseJson);
                }catch (e){
                    console.error(e.message);
                    reject()
                }
            })
            .catch((e) => {
                console.error(e.message);
                reject()
            });
    });
};

const MunicipalityAPI = {
    detail: detail
};

export default MunicipalityAPI;
